module.exports = __webpack_public_path__ + "static/img/foshologo2.82c99553.png";